import React, {Component} from 'react';
import couterpart from 'counterpart';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Dialog from 'react-bootstrap-dialog';
import { FaFilter } from 'react-icons/fa';
import {TiArrowBackOutline} from 'react-icons/ti';

import MenuComponent2 from './MenuComponent2';
import MaterialList from './MaterialList';
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import queryString from 'query-string'
import MasterDataService from '../services/MasterDataService';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ICON_COLOR } from '../icon';
import { 
    WO_QUAYKIM, 
    WO_XI, WO_TOBE_FIXED, 
    MATERIAL_COLOR_BAC, 
    MATERIAL_COLOR_VANG, 
    MATERIAL_COLOR_HONG, 
    SELECTED_MATERIAL_BAC, 
    SELECTED_MATERIAL_VANG_LAC_KE, 
    SELECTED_MATERIAL_VANG_TRANG_TRI, 
    SELECTED_MATERIAL_HONG_LAC_KE, 
    SELECTED_MATERIAL_HONG_TRANG_TRI,
    SELECTED_MATERIAL_XI_LOI,
    XI_MODE_NORMAL,
    XI_MODE_FIX, 
    XI_TYPE_TRANGTRI,
    XI_TYPE_BAC,
    XI_TYPE_LACKE} from '../constants';

//xiType: 0: BAC, 1: 'LẮC KÊ', 2: 'TRANG TRÍ'
class XiScan extends Component {
    constructor() {
        super();
        this.state = {
            selectedMaterial: 'INIT',
            allStatus: [],
            workOrder: {},
            workOrderId: null,
            updated: false,
            options: "",
            status: 0,
            inputOrderNo: '',
            show: false,
            show2: false,
            show3: false,
            show4: false,
            show5: false,
            roundInfo: {
            },
            todayRounds: {
                activeRound: {},
                rounds: []
            },
            fixXi: 0, //1: Xi (bac, vang, hong), 2: Fix xi (trang tri vang | trang tri hong)
            selectedError: 0,
            selectedErrorDesc: '',
            countRefesh: 0,
            errorGroups: [
                {
                    id: 1, name:'Lỗi trước xi',
                    errors: [
                        {id: 0, name: ''},
                        {id: 1, name: 'Cắt/Khắc sai TK', mapTo: 54},
                        {id: 2, name: 'TK sai, trả về TK', mapTo: 32},
                        {id: 3, name: 'Sai size', mapTo: 54},
                        {id: 4, name: 'Sai kỹ thuật', mapTo: 54},
                        {id: 5, name: 'Cắt khắc sai', mapTo: 54},
                        {id: 6, name: 'Bạc dộp', mapTo: 54},
                        {id: 7, name: 'Quay kim không đủ, không đều', mapTo: 54},
                        {id: 8, name: 'xước, mẻ, lỗ bề mặt', mapTo: 54},
                        {id: 11, name: 'Lỗi mối hàn', mapTo: 54},
                        {id: 10, name: 'Lỗi khác', mapTo: 54},
                        {id: 13, name: 'Lỗi khác (Thợ)', mapTo: 54}, 
                    ]                    
                },
                {
                    id: 2, name: 'Lỗi xi',
                    errors: [
                        {id: 0, name: ''},
                        {id: 12, name: 'Đám mây', mapTo: 54},
                        {id: 13, name: 'Xước bề mặt', mapTo: 54},
                        {id: 14, name: 'Cháy mặt', mapTo: 54},
                        {id: 15, name: 'Lỗi keo', mapTo: 54},
                        {id: 16, name: 'Bẩn bề mặt', mapTo: 54}
                    ]
                },
            ],
            errorCodes: [],
            materialItems: [
                {code: 'HONG_LAC_KE', name: 'HỒNG LẮC KÊ - TIẾP TỤC'},
                {code: 'VANG_LAC_KE', name: 'VÀNG LẮC KÊ - TIẾP TỤC'},
                {code: 'BAC', name: 'BẠC'},
                {code: 'HONG_TRANG_TRI', name: 'HỒNG TRANG TRÍ -  TIẾP TỤC'},
                {code: 'VANG_TRANG_TRI', name: 'VÀNG TRANG TRÍ -  TIẾP TỤC'},
                {code: 'XI_LOI', name: 'XI LỖI'},
            ],
        };
        // this.scanInput = React.createRef();
        this.materialList = React.createRef();
    };

    componentDidMount () {  

        const query = queryString.parse(this.props.location.search);
        if (query.caller === '0'){ //Clicked on NAV
            WorkOrderUtil.removeItem("kimWo.woNo");
        }

        MasterDataService.retrieveAllStatus().then(data => {
            this.setState({ allStatus:  data}) 
        });

        let group = this.state.errorGroups.find(it => {
            return it.id === 1 //Loi truoc xi  
        });
        if (group != undefined){
            this.setState({
                errorCodes: group.errors
            });
        }

        this.loadTodayRound();      
    }

    loadTodayRound(){
        WorkOrderDataService.fetchTodayRounds().then(data => {
            // console.log(data);
            this.setState({
                todayRounds: data
            });
        });
    }

    endRound(){
        console.log(this.state.todayRounds.activeRound);
        WorkOrderDataService.endActiveRound(this.state.todayRounds.activeRound.id).then(data => {
            if (data === 1) {
                alert('Đã kết thúc mẻ hiện tại.');
                this.loadTodayRound();
            } else {
                alert('Lỗi. Không thể kết thúc mẻ hiện tại.');
            }
        });
    }

    getCurrentStatus(status){
        if (this.state.allStatus === undefined || this.state.allStatus.length < 1){
            return status;
        }

        let currentStatus = this.state.allStatus.find(x => {
            return x.status === status;
        });
        return currentStatus? currentStatus.statusDescVn : status;
    }     

    renderOption(option){
        return (
            <option key={option.key} value={option.value}>{option.label}</option>
        );
    }

    renderWorkerByRole(){
        if (!AuthenticationService.isAdmin()){
            return (<label>{this.state.workOrder.workerFullName}</label>);
        }

        if((this.state.selectOptions ===undefined) || (this.state.selectOptions === null)){
            return (<></>);
        }
        return(
        <select defaultValue={this.state.workOrder.worker} onChange={this.handleSelectChange.bind(this)}>
        {this.state.selectOptions !== undefined && this.state.selectOptions.map(option =>this.renderOption(option))}
        </select>
        );
    }  

    handleOrderNoChange(e){
        var value = e.target.value;
        sessionStorage.setItem("scanWorkOrder.inputOrderNo", value)
        this.setState(prevState => ({                 
            inputOrderNo: value                   
        }));
    }

    filterWorkOrdersByNoForKim(){   
        var no = this.state.orderNo;
        if (no === undefined || no === null || no.trim().length < 1){          
            return;
        }

        WorkOrderDataService.scanByNo(`${no}`).then(data => {
            // let beShown = false;
            // if (data.status !== WO_XI){
            //     beShown = true;
            // }

            let matched = false;
            if (this.getPostfix(data.colorMaterial) === MATERIAL_COLOR_HONG && (this.state.selectedMaterial === SELECTED_MATERIAL_HONG_LAC_KE || this.state.selectedMaterial === SELECTED_MATERIAL_HONG_TRANG_TRI)){
                matched = true;
            } else if (this.getPostfix(data.colorMaterial) === MATERIAL_COLOR_VANG && (this.state.selectedMaterial === SELECTED_MATERIAL_VANG_LAC_KE || this.state.selectedMaterial === SELECTED_MATERIAL_VANG_TRANG_TRI)){
                matched = true;
            } else if (this.getPostfix(data.colorMaterial) === MATERIAL_COLOR_BAC && (this.state.selectedMaterial === SELECTED_MATERIAL_BAC)){
                matched = true;
            } else if (this.state.selectedMaterial === "XI_LOI"){
                matched = true;
            }

            if (!matched){
                alert("Đơn hàng đươc xi ("+ data.colorMaterial +") không đúng với loại xi (" + this.state.selectedMaterial  +")."); 
            } else {
                //Khi chon vang trang tri hoac hong trang tri, tinh trang cua wo phai la to be fixed
                if ((data.status !== WO_TOBE_FIXED) && ( this.state.selectedMaterial === SELECTED_MATERIAL_VANG_TRANG_TRI || this.state.selectedMaterial === SELECTED_MATERIAL_HONG_TRANG_TRI)){
                    alert("Đơn hàng có màu ("+ data.colorMaterial +") phải trong tình trạng cần sửa chữa (" + this.state.selectedMaterial  +")."); 
                } else {
                    this.setState({ 
                        workOrderId: data.id,
                        workOrder:  data,
                        updated: true,
                    }, () => {
                        if (this.state.workOrder.status !== WO_QUAYKIM){
                            if (this.state.workOrder.status === WO_TOBE_FIXED){
                                if (this.state.selectedMaterial === SELECTED_MATERIAL_VANG_TRANG_TRI){
                                    this.changeWorkOrderToFixXi();
                                } else {
                                    if (this.state.selectedMaterial ===  SELECTED_MATERIAL_HONG_TRANG_TRI){
                                        this.changeWorkOrderToFixXi();
                                    }
                                }
                            }
                        } else if (this.state.selectedMaterial === SELECTED_MATERIAL_BAC){
                            this.changeWorkOrderToXi();
                        } else if (this.state.selectedMaterial === SELECTED_MATERIAL_VANG_LAC_KE){
                            this.changeWorkOrderToXi();
                        } else if (this.state.selectedMaterial === SELECTED_MATERIAL_VANG_TRANG_TRI){
                            this.changeWorkOrderToFixXi();
                        } else if (this.state.selectedMaterial === SELECTED_MATERIAL_HONG_LAC_KE){
                            this.changeWorkOrderToXi();
                        } else if (this.state.selectedMaterial === SELECTED_MATERIAL_HONG_TRANG_TRI){
                            this.changeWorkOrderToFixXi();
                        } else if (this.state.selectedMaterial === SELECTED_MATERIAL_XI_LOI){
                            this.onLoiClicked();
                        }
                    });
                }
            }            
        });
    }    

    processOrder(){
        let orderNo = this.state.inputOrderNo;
        this.setState({ 
            workOrderId: 0,
            workOrder:  {},
            show: false,
            updated: false,
            orderNo: orderNo
        }, () => {
            if (this.state.orderNo !== undefined && this.state.orderNo.trim().length > 0){
                this.filterWorkOrdersByNoForKim()
            }
        });
    }

    selectMaterialToXi(material){
        this.setState({ 
            selectedMaterial: material,
            workOrder: {},
            inputOrderNo: ''
        }, () => {
            this.materialList.current.refreshProfileXis(material);
        });
    }

    onRoundHistory(){
        this.setState({ show5: true });
    }      

    handleKeyDown(e){
        if (e.key === 'Enter') {
            this.processOrder()
        }
    }

    handleShow() {
		this.setState({ show: true });
	}

    handleClose(){
        this.materialList.current.refreshMe();
        this.setState({ show: false, inputOrderNo: '', countRefesh: this.state.countRefesh + 1 },
        () => {
            this.sleep(500).then(() => {
                this.scanWorkOrderNo.focus();
            })
        });
    }

    handleClose2(){
        this.setState({ show2: false, countRefesh: this.state.countRefesh + 1 },
        () => {
            this.sleep(500).then(() => {
                this.scanWorkOrderNo.focus();
            })
        });
    } 

    handleClose3(){
        this.setState({ show3: false, countRefesh: this.state.countRefesh + 1 },
        () => {
            this.sleep(500).then(() => {
                this.scanWorkOrderNo.focus();
            })
        });
    }

    onTiepTuc(){
        if (this.state.fixXi === XI_MODE_NORMAL){
            this.setState({ show4: false, show: false, fixXi: 0 },
            () => {
                let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                wo.status = WO_XI;
                wo.step = 'XI';
                wo.roundEnded = 0;
                if (this.state.selectedMaterial === SELECTED_MATERIAL_BAC){
                    wo.xiType = XI_TYPE_BAC;
                } else {
                    wo.xiType = XI_TYPE_LACKE;
                }
                this.setState({
                    workOrder:  wo,
                    inputOrderNo: ''           
                }, () => {
                    WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                        if (data.updated === 1){
                            this.loadTodayRound();                       
                            this.handleClose();
                        } else {
                            console.log(data);
                            alert('Lỗi xảy ra (Có thể do hết nước xi ..), không thể cập nhật.');
                        }
                    });
                });
            });
        } else {
            if (this.state.fixXi === XI_MODE_FIX){
                this.setState({ show4: false, show: false, fixXi: 0 },
                () => {
                    let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                    wo.status = WO_XI;
                    wo.fixLoiXi = 1;
                    wo.step = 'XI';
                    wo.roundEnded = 0;
                    if (this.state.selectedMaterial === SELECTED_MATERIAL_BAC){
                        wo.xiType = XI_TYPE_BAC;
                    } else {
                        wo.xiType = XI_TYPE_TRANGTRI;
                    }
                    
                    this.setState({
                        workOrder:  wo,
                        inputOrderNo: ''           
                    }, () => {
                        WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                            if (data.updated === 1){
                                this.loadTodayRound();                   
                                this.handleClose();
                            } else {
                                console.log(data);
                                alert('Lỗi xảy ra (Có thể do hết nước xi ..), không thể cập nhật.');
                            }
                        });
                    });
                });
            }
        }
    }

    onAbort () {
        this.setState({ show4: false, show: false});
    }

    onAbortRoundHistory () {
        this.setState({ show5: false});
    }

    onCancelled () {
        if (this.state.fixXi === XI_MODE_NORMAL){
            this.setState({ show4: false, show: false, fixXi: 0 },
            () => {
                let roundEnded = 0;
                let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                wo.status = WO_XI;
                wo.step = 'XI';
                wo.roundEnded = 1;
                if (this.state.selectedMaterial === SELECTED_MATERIAL_BAC){
                        wo.xiType = XI_TYPE_BAC;
                    } else {
                        wo.xiType = XI_TYPE_LACKE;
                    }
                this.setState({
                    workOrder:  wo,
                    inputOrderNo: ''           
                }, () => {
                    WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                        if (data.updated === 1){
                            this.loadTodayRound();                   
                            this.handleClose();
                        } else {
                            console.log(data);
                            alert('Lỗi xảy ra (Có thể do hết nước xi ..), không thể cập nhật.');
                        }
                    });
                });
            });
        } else {
            if (this.state.fixXi === XI_MODE_FIX){
                this.setState({ show4: false, show: false, fixXi: 0 },
                () => {
                    let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                    wo.status = WO_XI;
                    wo.fixLoiXi = 1;
                    wo.step = 'XI';
                    wo.roundEnded = 1;
                    if (this.state.selectedMaterial === SELECTED_MATERIAL_BAC){
                        wo.xiType = XI_TYPE_BAC;
                    } else {
                        wo.xiType = XI_TYPE_TRANGTRI;
                    }
                    this.setState({
                        workOrder:  wo,
                        inputOrderNo: ''           
                    }, () => {
                        WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                            if (data.updated === 1){
                                this.loadTodayRound();                   
                                this.handleClose();
                            } else {
                                console.log(data);
                                alert('Lỗi xảy ra (Có thể do hết nước xi ..), không thể cập nhật.');
                            }
                        });
                    });
                });
            }
        }
    }    

    renderErrorOption(error){
        return (
            <option key={error.id} value={error.id}>{error.name}</option>
        );
    }    

    renderErrors(){
        return(
        <select onChange={this.handleErrorChange.bind(this)}>
        {this.state.errorCodes !== undefined && this.state.errorCodes.map(error =>this.renderErrorOption(error))}
        </select>
        );
    }

    renderErrorGroups(){
        return(
        <select onChange={this.handleErrorGroupChange.bind(this)}>
        {this.state.errorGroups !== undefined && this.state.errorGroups.map(error =>this.renderErrorOption(error))}
        </select>
        );
    }

    getErrorDesc(id){
        let err = this.state.errorCodes.find(it => {
            return it.id == id
        })
        if (err){
            return err.name;
        }
        return id;
    }

    handleErrorGroupChange(e){
        var value = e.target[e.target.selectedIndex].value;
        
        let group = this.state.errorGroups.find(it => {
            return it.id == value
        });

        if (group !== undefined){
            console.log('group.errors', group);
            this.setState({ 
                errorCodes: group.errors 
            });
        }
    }

    handleErrorChange(e){
        var value = e.target[e.target.selectedIndex].value;
        let mapStatus = 0;
        if (value == 2){
            mapStatus = 32;
        } else {
            mapStatus = 54;
        }
        console.log('mapStatus', mapStatus)

        let desc = this.getErrorDesc(value);
        this.setState({               
            selectedError: value,
            selectedErrorDesc: desc,
            status: mapStatus              
        });
    }        

    handleEdit(wo){     
        this.setState({ 
            workOrderId: 0,
            workOrder:  {},
            show: false,
            updated: false,
            inputOrderNo: wo.workOrderNo,
            orderNo: wo.workOrderNo
        }, () => {
            if (this.state.orderNo !== undefined && this.state.orderNo.trim().length > 0){
                this.filterWorkOrdersByNoForKim()
            }
        });
    }

    changeWorkOrderToXi(){
        console.log('WO', this.state.workOrder);
        if (this.state.workOrder.status != WO_QUAYKIM && this.state.workOrder.status != WO_TOBE_FIXED){
            alert(couterpart.translate('work_order_invalid_status'));
            return;
        }

        WorkOrderDataService.fetchRoundInfoBy({code: this.state.workOrder.colorMaterial, round: this.state.workOrder.roundCount, xiType: 1}).then(data => {
            //console.log('ROUNDINFO', data);
            this.setState({ show4: true, fixXi: 1, roundInfo: data  });
        });
    }

    changeWorkOrderToFixXi(){
        if (this.state.workOrder.status != WO_QUAYKIM && this.state.workOrder.status != WO_TOBE_FIXED){
            alert(couterpart.translate('work_order_invalid_status'));
            return;
        }

        WorkOrderDataService.fetchRoundInfoBy({code: this.state.workOrder.colorMaterial, round: this.state.workOrder.roundCount, xiType: 2}).then(data => {
            //console.log('ROUNDINFO', data);
            this.setState({ show4: true, fixXi: 2, roundInfo: data });
        });
        
        // let ans = window.confirm(couterpart.translate('round_ended'));
        // let roundEnded = 0;
        // if(ans){
        //     roundEnded = 1;
        // } 

        // let wo = JSON.parse(JSON.stringify(this.state.workOrder))
        // wo.status = WO_XI;
        // wo.fixLoiXi = 1;
        // wo.step = 'XI';
        // wo.roundEnded = roundEnded;
        // this.setState({
        //     workOrder:  wo,
        //     inputOrderNo: ''           
        // }, () => {
        //     WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {                         
        //         this.handleClose();
        //     });
        // });
    }

    changeWorOrderToError(){
        if (this.state.selectedError <=0){
            alert(couterpart.translate('msg_error_missing'));
            return;
        }
        this.dialog.show({
            title: couterpart.translate("msg_title_confirm"),
            body: couterpart.translate("msg_change_confirm"),
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() =>{
                    let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                    let note = this.state.shippingNote? ': ' + this.state.shippingNote: '';
                    wo.status = this.state.status
                    wo.errorCode = this.state.selectedError
                    wo.step = 'XI';
                    if (wo.errorCode == 9){ //Loi xi
                        wo.errorCount = wo.errorCount + 1
                    }
                    wo.shippingNote = this.state.selectedErrorDesc + note
                    this.setState({
                        workOrder:  wo,
                        inputOrderNo: '',
                        action: 1,
                        show3: false
                    }, () => {
                        WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                            this.handleClose();                          
                        });
                    });
                })
            ],
            bsSize: 'small',
            onHide: (dialog) => {
                dialog.hide()
                console.log('closed by clicking background.')
            }
        }); 
    }

    renderScanTypeSelection() {
        if (this.state.selectedMaterial !== "INIT") {
            return (<></>);
        }

        return (
            <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-2">
                    &nbsp;
                </div>
                <div className="col-2" style={{ marginLeft: "50px" }}>
                    <button className="myButton"  onClick={ this.selectMaterialToXi.bind(this, "VANG_LAC_KE") } style={{ height: "70px", width: "150px", backgroundColor: "yellow"}}>
                        { couterpart.translate('button_xi_vang') }
                    </button>
                    <button className="myButton"  onClick={ this.selectMaterialToXi.bind(this, "VANG_TRANG_TRI") } style={{ height: "70px", width: "150px", backgroundColor: "yellow"}}>
                        { couterpart.translate('button_xi_fix_vang') }
                    </button>
                    <button className="myButton"  onClick={ this.selectMaterialToXi.bind(this, "HONG_LAC_KE") } style={{ height: "70px", width: "150px", backgroundColor: "pink"}}>
                        { couterpart.translate('button_xi_hong') }
                    </button>
                    <button className="myButton"  onClick={ this.selectMaterialToXi.bind(this, "HONG_TRANG_TRI") } style={{ height: "70px", width: "150px", backgroundColor: "pink"}}>
                        { couterpart.translate('button_xi_fix_hong') }
                    </button>
                    <button className="myButton"  onClick={ this.selectMaterialToXi.bind(this, "BAC") } style={{ height: "70px", width: "150px", backgroundColor: "silver"}}>
                        { couterpart.translate('button_xi_bac_type') }
                    </button>
                    <button className="myButton"  onClick={ this.selectMaterialToXi.bind(this, "XI_LOI") } style={{ height: "70px", width: "150px", backgroundColor: "red"}}>
                        { couterpart.translate('button_xi_loi') }
                    </button>
                    <Button className="myButton"  onClick={this.onRoundHistory.bind(this)} style={{ height: "70px", width: "150px", backgroundColor: "brown"}}>
                        { couterpart.translate('button_round_history') }
                    </Button>
                </div>
                <div className="col-6">
                    <MaterialList countRefesh = { this.state.countRefesh } ref = {this.materialList} />
                </div>
                <Modal show={this.state.show5} onHide={this.onAbortRoundHistory.bind(this)} backdrop="static" dialogClassName="modal-60w">
                    <Modal.Header closeButton style={{ backgroundColor: "lightblue"}}>
                        <Modal.Title>{ couterpart.translate("round_history") }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal-60h">
                        <div className="row">
                            <div className="col-12">
                                { this.renderRounds()}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    getXiTypeDesc(type){
        for(let i=0; i<this.state.materialItems.length; i++){
            if (this.state.materialItems[i].code === type) {
                return this.state.materialItems[i].name;
            }
        }
        return type;
    }

    renderTitle(title){
        if (this.state.selectedMaterial === 'BAC'){
            return (
                <>
                <label htmlFor="" style={{ ccolor: "black", backgroundColor:'silver'}}> {title } </label>
                </>
            )
        }

        if (this.state.selectedMaterial === 'VANG_LAC_KE'){
            return (
                <>
                <label htmlFor="" style={{ color: "black", backgroundColor:'yellow'}}> {title } </label>
                </>
            )
        }

        if (this.state.selectedMaterial === 'VANG_TRANG_TRI'){
            return (
                <>
                <label htmlFor="" style={{ ccolor: "black", backgroundColor:'yellow'}}> {title } </label>
                </>
            )
        }

        if (this.state.selectedMaterial === 'HONG_LAC_KE'){
            return (
                <>
                <label htmlFor="" style={{ ccolor: "black", backgroundColor:'pink'}}> {title } </label>
                </>
            )
        }

        if (this.state.selectedMaterial === 'HONG_TRANG_TRI'){
            return (
                <>
                <label htmlFor="" style={{ ccolor: "black", backgroundColor:'pink'}}> {title } </label>
                </>
            )
        }

        if (this.state.selectedMaterial === 'XI_LOI'){
            return (
                <>
                <label htmlFor="" style={{ ccolor: "black", backgroundColor:'red'}}> {title } </label>
                </>
            )
        }

        return (<>{ title }</>);
    }

    renderSelectedMaterialScan(){
        if (this.state.selectedMaterial === "INIT") {
            return (<></>);
        }
        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-2">
                            <button className="myButton"  onClick={ this.selectMaterialToXi.bind(this, "INIT") }>
                                <TiArrowBackOutline color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_back')}
                            </button>
                        </div>
                        <div className="col-10" style={{ marginTop: "5px", width: "100%" }}>
                           <h2> { this.renderTitle(this.getXiTypeDesc(this.state.selectedMaterial)) } </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-2">
                            <input type="text" value={this.state.inputOrderNo} 
                                style={{ marginTop: "5px", width: "100%" }}
                                name="scanWorkOrderNo" 
                                id="scanWorkOrderNo" 
                                autoFocus ref={ input => this.scanWorkOrderNo = input }
                                placeholder={couterpart.translate('order_no')}
                                onChange={this.handleOrderNoChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}/>
                        </div>
                        <div className="col-1">
                            <button className="myButton"  onClick={ this.processOrder.bind(this) }>
                                <FaFilter color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_filter')}
                            </button>
                        </div>
                        <div className="col-9">
                            &nbsp;
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            { this.renderDetails() }
                        </div>
                        <div className="col-6">
                            <MaterialList countRefesh = { this.state.countRefesh } ref = {this.materialList} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }    

    renderDetails () {
        if (this.state.workOrder.workOrderNo === undefined){
            return (<div>&nbsp;
            </div>)
        }
        
        return (
            <>
                <div className="row">
                    <div className="col-11">
                        &nbsp;
                    </div>
                    <div className="col-1">
                        { this.renderUpdateButton() }
                    </div>
                </div>            
                <div className="row">&nbsp;</div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-4 border-top border-left border-light-gray">
                                <div className="row"><img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode}/></div>
                                <div className="row">
                                    <label className="label_link" onClick={ this.handleEdit.bind(this, this.state.workOrder) }> {this.state.workOrder.workOrderNo} </label>
                                </div>
                            </div>
                            <div className="col-8 border-top border-left border-light-gray">
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_order_date_s') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_leadTimeProduction') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.leadTimeProduction)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_worker') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{this.renderWorkerByRole()}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{couterpart.translate('work_order_end_date')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs) }</div>
                                </div>
                                <div className="row border-bottom border-light-gray"> 
                                    <div className="col">
                                        <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <label className="labelValueBox">{
                                            WorkOrderUtil.formatShortDisplayDateMMddyyyy3(this.state.workOrder.ngayNhapLieu) 
                                        }</label>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_code')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.sku}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('shop_pcode')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.fullPCode}</div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_color')}</b></div>
                            <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_type')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.shapeDesign}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_quantity_s')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.qty}</div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_size')}</b></div>
                            <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.lengthSize}</label></div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-bottom border-light-gray"><b>{couterpart.translate('work_order_font')}</b></div>
                            <div className="col-5 border-top border-left border-bottom border-right border-light-gray"><pre>{this.state.workOrder.font}</pre></div>
                            <div className="col-2 border-top border-left border-bottom border-light-gray"><b>{couterpart.translate('work_order_personalization')}</b></div>
                            <div className="col-3 border-top border-left border-right border-bottom border-light-gray"><pre style={{ 'fontSize': '20px'}}>{this.state.workOrder.personalization}</pre></div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-bottom border-light-gray"><b>{couterpart.translate('work_order_status')}</b></div>
                            <div className="col-2 border-top border-left border-bottom border-right border-light-gray">{ this.getCurrentStatus(this.state.workOrder.status) }</div>
                            <div className="col-8 border-top border-left border-bottom border-right border-light-gray">{ this.state.workOrder.shippingNote }</div>
                        </div>                        
                    </div>
                    {/* <div className="col-4">
                        <WorkOrderImages mode="MODE_EDIT"  workOrderId={this.state.workOrderId}  largeMode={1}  
                            isUpdated={this.state.updated}/>                    
                    </div> */}
                    {/* <div className="col-6">
                        <MaterialList countRefesh = { this.state.countRefesh } ref = {this.materialList} />
                    </div> */}
                </div>
                <div className="row">
                    <div className="col-12  border-left border-right border-bottom border-light-gray">
                        <WorkOrderImages workOrderId={this.state.workOrderId}  largeMode={0}  
                            isUpdated={this.state.updated}/>
                    </div>
                </div>
                <Dialog ref={(component) => { this.dialog = component }} />
                <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static" dialogClassName="modal-60w">
                    <Modal.Header closeButton style={{ backgroundColor: "lightblue"}}>
                        <Modal.Title>{ couterpart.translate('lbl_caption_update') }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-10">
                                <div className="row">
                                    <div className="col-6">
                                        <span>{ couterpart.translate('work_order_no') } : </span>
                                    </div>
                                    <div className="col-6">
                                        { this.state.workOrder.workOrderNo }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <span>{ couterpart.translate('shop_pcode') } : </span>
                                    </div>
                                    <div className="col-6">
                                        { this.state.workOrder.fullPCode }
                                    </div>                                                       
                                </div>
                            </div>
                            <div className="col-2">
                                <div className="row">
                                    <div className="col-12">
                                        { couterpart.translate('so_me') }: { this.state.workOrder.roundCount }
                                    </div>                                                        
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <label style={{ fontWeight: 'bold', color:'green' }}>{ couterpart.translate('so_me_active')} ({ this.state.workOrder.activeColor })</label>
                            </div>                                                        
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <label style={{ color: 'red' }}>{ this.state.workOrder.isColorActive === 1? '':  couterpart.translate('so_me_inactive') + '(' + this.state.workOrder.colorMaterial + ')'}</label>
                            </div>                                                        
                        </div>                      
                    </Modal.Body>
                    <Modal.Footer>                       
                        { this.renderTiepTuc(this.state.workOrder.xiType) }
                        { <Button variant="primary" onClick={this.onLoiClicked.bind(this)}>{ this.getXiLoiCaptions() }</Button> }
                        { <Button variant="primary" onClick={this.handleClose.bind(this)}>{ couterpart.translate('button_cancel') }</Button>}                         
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.show3} onHide={this.handleClose3.bind(this)} backdrop="static" dialogClassName="modal-40w">
                    <Modal.Header closeButton style={{ backgroundColor: "lightblue"}}>
                        <Modal.Title>{ couterpart.translate("msg_title_confirm") }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-2">
                                { this.renderErrorGroups() }
                            </div>
                            <div className="col-5">
                                { this.renderErrors() }
                            </div>
                            <div className="col-5">
                                <input type="text" name="shippingNote" className="inputBox3" placeholder={couterpart.translate('label_note')}
                                    onChange={this.handleKimNoteChange.bind(this)}  onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleKimNoteChange(e) }, 0); }} />
                            </div>                            
                        </div>
                        <div className="row">&nbsp;</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleClose3.bind(this)}>Cancel</Button>
                        <Button variant="primary" onClick={this.changeWorOrderToError.bind(this)}>OK</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.show4} onHide={this.onAbort.bind(this)} backdrop="static" dialogClassName="modal-40w">
                    <Modal.Header closeButton style={{ backgroundColor: "lightblue"}}>
                        <Modal.Title>{ couterpart.translate("round_ended") }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-7">
                               Mẻ hiện tại: 
                            </div>
                            <div className="col-5">
                                { this.state.roundInfo.roundNo }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-7">
                               Số item trong mẻ hiện tại:
                            </div>
                            <div className="col-5">
                                { this.state.roundInfo.count }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-7">
                               Thời gian của mè:
                            </div>
                            <div className="col-5">
                                { this.state.roundInfo.createdAt }
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div style={{ width: "80%", marginLeft: "10%", textAlign: "center" }}>
                               <Button className="btn-primary-g" style={{ backgroundColor: "red", color:'black' }}  onClick={this.onTiepTuc.bind(this)} style={{ marginRight: "20px", width:"100px", height:"70px"}}>TIẾP TỤC MẺ</Button>
                               <Button className="btn-primary-r"  style={{ backgroundColor: "silver", color:'black' }}  onClick={this.onCancelled.bind(this)} style={{ marginRight: "20px", width:"100px", height:"70px" }}>KẾT THÚC MẺ</Button>
                               <Button style={{ backgroundColor: "silver", color:'black' }}  onClick={this.onAbort.bind(this)} style={{ width:"100px", height:"70px" }}>HỦY BỎ</Button>
                            </div>                                                        
                        </div>
                    </Modal.Body>
                </Modal>                                           
            </>
        )
    }

    renderTiepTuc(xiType){
        //CHON XI BAC
        if (this.state.workOrder.colorMaterial === MATERIAL_COLOR_BAC){
            return (
                <>
                <Button variant="primary" onClick={ this.changeWorkOrderToXi.bind(this) }>{ this.getXiCaptions(this.state.workOrder.colorMaterial) }</Button>
                </>
            )
        }

        //CHON XI VANG
        if (this.getPostfix(this.state.workOrder.colorMaterial) === MATERIAL_COLOR_VANG){
            if (xiType === 0){
                return (
                    <>
                    <Button style={{ backgroundColor:'yellow', color:'black' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ this.getXiCaptions(this.state.workOrder.colorMaterial) }</Button>
                    <Button style={{ backgroundColor:'yellow', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ this.getXiFixCaptions(this.state.workOrder.colorMaterial) }</Button>
                    </>
                )
            }

            if (xiType === 1){
                return (
                    <>
                    <Button style={{ backgroundColor:'yellow', color:'black' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ this.getXiCaptions(this.state.workOrder.colorMaterial) }</Button>
                    </>
                )
            }

            if (xiType === 2){
                return (
                    <>
                    <Button style={{ backgroundColor:'yellow', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ this.getXiFixCaptions(this.state.workOrder.colorMaterial) }</Button>
                    </>
                )
            }
        }

        //CHON XI HONG
        if (this.getPostfix(this.state.workOrder.colorMaterial) === MATERIAL_COLOR_HONG){
            if (xiType === 0){
                return (
                    <>
                    <Button style={{ backgroundColor:'pink', color:'black' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ this.getXiCaptions(this.state.workOrder.colorMaterial) }</Button>
                    <Button style={{ backgroundColor:'pink', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ this.getXiFixCaptions(this.state.workOrder.colorMaterial) }</Button>
                    </>
                )
            }

            if (xiType === 1){
                return (
                    <>
                    <Button style={{ backgroundColor:'pink', color:'black' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ this.getXiCaptions(this.state.workOrder.colorMaterial) }</Button>
                    </>
                )
            }

            if (xiType === 2){
                return (
                    <>
                    <Button style={{ backgroundColor:'pink', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ this.getXiFixCaptions(this.state.workOrder.colorMaterial) }</Button>
                    </>
                )
            }                        
        }
        return (
            <>
            <Button style={{ backgroundColor:'silver' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ this.getXiCaptions(this.state.workOrder.colorMaterial) }</Button>
            <Button style={{ backgroundColor:'silver' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ this.getXiFixCaptions(this.state.workOrder.colorMaterial) }</Button>
            </>
        )
    }

    renderUpdateButton(){
        if (this.state.workOrder.status !== WO_QUAYKIM){
            if (this.state.workOrder.status === WO_TOBE_FIXED){
                if (this.state.selectedMaterial === SELECTED_MATERIAL_VANG_TRANG_TRI){
                    return (
                        <>
                        <Button style={{ backgroundColor:'yellow', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ couterpart.translate('button_xi_confirm') }</Button>
                        </>
                    )
                }

                if (this.state.selectedMaterial ===  SELECTED_MATERIAL_HONG_TRANG_TRI){
                    return (
                        <>
                        <Button style={{ backgroundColor:'pink', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ couterpart.translate('button_xi_confirm') }</Button>
                        </>
                    )
                }
            }
            return (<></>);
        }
        if (this.state.selectedMaterial === SELECTED_MATERIAL_BAC){
            return (
                <>
                <Button style={{ backgroundColor:'silver', color:'black' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ couterpart.translate('button_xi_confirm') }</Button>
                </>
            )
        }

        if (this.state.selectedMaterial === SELECTED_MATERIAL_VANG_LAC_KE){
            return (
                <>
                <Button style={{ backgroundColor:'yellow', color:'black' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ couterpart.translate('button_xi_confirm') } </Button>
                </>
            )
        }

        if (this.state.selectedMaterial === SELECTED_MATERIAL_VANG_TRANG_TRI){
            return (
                <>
                <Button style={{ backgroundColor:'yellow', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ couterpart.translate('button_xi_confirm') }</Button>
                </>
            )
        }

        if (this.state.selectedMaterial === SELECTED_MATERIAL_HONG_LAC_KE){
            return (
                <>
                <Button style={{ backgroundColor:'pink', color:'black' }} onClick={ this.changeWorkOrderToXi.bind(this) }>{ couterpart.translate('button_xi_confirm') }</Button>
                </>
            )
        }

        if (this.state.selectedMaterial === SELECTED_MATERIAL_HONG_TRANG_TRI){
            return (
                <>
                <Button style={{ backgroundColor:'pink', color:'black' }} onClick={ this.changeWorkOrderToFixXi.bind(this) }>{ couterpart.translate('button_xi_confirm') }</Button>
                </>
            )
        }

        if (this.state.selectedMaterial === SELECTED_MATERIAL_XI_LOI){
            console.log(this.state.selectedMaterial);
            return (
                <>
                { <Button style={{ backgroundColor:'red', color:'black' }} onClick={this.onLoiClicked.bind(this)}>{ couterpart.translate('button_xi_confirm') }</Button> }
                </>
            )
        }

        return (<></>);    

    }

    getPostfix(color){
        let postfix = '';
        if (color === 'BẠC'){
            postfix = 'bac'
        } else if (color === 'VÀNG') {
            postfix = 'vang'
        } else if (color === 'HỒNG') {
            postfix = 'hong'
        }
        return postfix;
    }

    getXiCaptions(color){
        return couterpart.translate('button_xi_' + this.getPostfix(color));
    }

    getXiFixCaptions(color){
        return couterpart.translate('button_xi_fix_' + this.getPostfix(color));
    }

    getXiLoiCaptions(){
        return couterpart.translate('button_xi_loi');
    }    

    handleKimNoteChange(e){
        let vl = e.target.value
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder                
            },
            shippingNote: vl 
        }));  
    }    

    handleChangeStatus(act){
    }

    onLoiClicked(){
        this.setState({
            show3: true,
            shippingNote: ''
        });
    }    

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    renderRounds(){
        if (this.state.todayRounds.rounds === undefined || this.state.todayRounds.rounds === null){
            return (<></>)
        }
        return (
            <>
                {
                    this.state.todayRounds.rounds.map((item, index) => {
                        return(
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-1">&nbsp;</div>
                            <div className="col-10">
                                <div className="row">
                                    <div className="col-2"><b>Mẻ số:</b></div>
                                    <div className="col-5">{item.roundCount}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2"><b>Màu:</b> </div>
                                    <div className="col-5">{item.code} ({item.xiType === 1? 'LẮC KÊ': 'TRANG TRÍ'})</div>
                                </div>                        
                                <div className="row">
                                    <div className="col-2"><b>Bắt đầu lúc:</b> </div>
                                    <div className="col-5">{item.createdAt}</div>
                                </div>                        
                            </div>
                        </div>
                        );
                    })
                }
            </>
        );
    }

    renderTodayRound(){
        if (this.state.todayRounds.activeRound === undefined || this.state.todayRounds.activeRound === null){
            return (
                <>
                </>
            );
        }
        
        return (
            <div className="row justify-content-md-center" style={{ marginTop: "5px"}}>
                <div className="col-10">
                    <div className="row" style={{ border: "2px solid red", borderRadius: "25px" }}>
                        <div className="col-3">
                            <Button className="btn-primary-r"  style={{ backgroundColor: "silver", color:'black' }}  onClick={this.endRound.bind(this)} style={{ marginRight: "20px", width:"100px", height:"70px" }}>KẾT THÚC MẺ</Button>
                        </div>
                        <div className="col-9">
                            <div className="row">
                                <div className="col-2"><b>Đang làm mẻ số:</b></div>
                                <div className="col-5">{this.state.todayRounds.activeRound?this.state.todayRounds.activeRound.roundCount : ""}</div>
                            </div>
                            <div className="row">
                                <div className="col-2"><b>Màu:</b> </div>
                                <div className="col-5">{ this.state.todayRounds.activeRound? this.state.todayRounds.activeRound.code : ""} ({this.state.todayRounds.activeRound === undefined || this.state.todayRounds.activeRound === null? "" : this.state.todayRounds.activeRound.xiType === 1? 'LẮC KÊ': 'TRANG TRÍ'})</div>
                            </div>                        
                            <div className="row">
                                <div className="col-2"><b>Bắt đầu lúc:</b> </div>
                                <div className="col-5">{this.state.todayRounds.activeRound? this.state.todayRounds.activeRound.createdAt : ""}</div>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>
        );
    }

      
    render() {
        if (!AuthenticationService.isXi()){
            return (<div>Unauthorized access.</div>);
        }

        return (
            <div>
                <MenuComponent2/>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                { this.renderTodayRound() }
                { this.renderScanTypeSelection() }
                { this.renderSelectedMaterialScan() }        
            </div>
        );
    }
}

export default XiScan;